import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { XSquare } from 'react-bootstrap-icons'

export const FormModal = (props) => {

    const Title = props.title
    const Icon = props.icon
    const BodyContent = props.body
    const elementId = props.elementId
    const action = props.action
    const filterActive = props.filterActive || false

    const [show, setShow] = useState(false)

    const handleClose = () => {
        setShow(false)
        props.refreshData(true)
    }
    const handleShow = () => setShow(true)

    useEffect(() => {
        if (props.modalTrigger) {
            handleShow()
        }
    }, [props.modalTrigger])

    return (
        <Modal        
            size="lg"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className='bg-primary text-white'>
                <Modal.Title>{Icon} {Title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <BodyContent onSubmit={handleClose} elementId={elementId} action={action} filterActive={filterActive} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <XSquare /> <FormattedMessage id="textClose" defaultMessage="Close" />
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default FormModal